<template>
  <base-material-card color="primary" icon="mdi-barcode-scan" inline class="ml-0 px-5 py-4">
    <template v-slot:after-heading>
      <div class="display-2 font-weight-light">
        {{ title }}
      </div>
    </template>
    <v-form class="mt-5">
      <v-row align="center" class="mx-auto">
        <v-col cols="12" class="pb-1">
          <validation-provider id="titulo-variacao-preco-unitario" v-slot="{ errors }" rules="required|max:100">
            <v-text-field v-model="campos.titulo" label="Título" outlined :error-messages="errors" />
          </validation-provider>
        </v-col>
      </v-row>

      <v-row align="center" class="mx-auto">
        <v-col cols="12" class="pb-1 pt-0">
          <validation-provider id="tucs-variacao-preco-unitario" v-slot="{ errors }" rules="required">
            <v-select
              v-model="campos.tucs"
              :items="tucList"
              outlined
              multiple
              small-chips
              clearable
              clear-icon="mdi-close-circle"
              label="TUCs"
              :error-messages="errors"
            />
          </validation-provider>
        </v-col>
      </v-row>

      <v-row align="center" class="mx-auto">
        <v-col cols="12" class="pb-1 pt-0">
          <validation-provider id="variaveis-variacao-preco-unitario" v-slot="{ errors }" rules="required">
            <v-select
              v-model="campos.variaveis"
              :items="variaveisList"
              outlined
              multiple
              small-chips
              clearable
              clear-icon="mdi-close-circle"
              label="Variáveis"
              :error-messages="errors"
            />
          </validation-provider>
        </v-col>
      </v-row>
    </v-form>
  </base-material-card>
</template>

<script>
  export default {
    name: 'ParametrosVariacaoPrecoUnitario',

    components: {},

    props: {
      variacao: {
        required: false,
        type: Object,
        default: () => {}
      }
    },

    data() {
      return {
        campos: {
          titulo: '',
          tucs: [],
          variaveis: []
        },
        tucList: ['125', '135', '160', '190', '210', '255', '295', '330', '340', '345', '395', '565', '570', '575', '580'],
        variaveisList: [
          { value: 'ValorUnitario', text: 'Valor Unitário' },
          { value: 'AliquotaICMS', text: 'Alíquota ICMS' },
          { value: 'AliquotaIPI', text: 'Alíquota IPI' }
        ]
      };
    },

    computed: {
      title() {
        return this.$route.params.id ? 'Editando Variação de Preço Unitário' : 'Adicionar Variação de Preço Unitário';
      },
      user() {
        return this.$store.getters.getUser;
      }
    },

    methods: {
      exportData() {
        return {
          nome: this.campos.titulo,
          parametros: {
            tucs: this.campos.tucs,
            vars: this.campos.variaveis
          }
        };
      },
      fillFields() {
        const item = this.variacao;

        this.campos.titulo = item.nome;
        this.campos.tucs = item.parametros?.tucs;
        this.campos.variaveis = item.parametros?.vars;
      }
    },

    watch: {
      variacao() {
        this.fillFields();
      }
    }
  };
</script>

<style>
</style>